<template>
    <teleport to="#modal">
        <Loading
            :visible="loading||listaPianoFatturazione.loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto py-3">
        <div class="m-auto px-8">

            <h1 class="text-3xl font-bold">Piano di fatturazione</h1>

            <div class="grid grid-cols-12 mb-2 gap-2 pt-4">
                <div class="col-span-1 flex flex-col">
                    <Field field_name="Stato">
                        <VueMultiselect
                            v-model="stato_filter"
                            :options="stato_options"
                            placeholder="Stato"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="text"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="true"
                            :close-on-select="true"
                            :clear-on-select="true"
                        >
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="col-span-2 flex flex-col mb-3">
                    <Field field_name="Termini di pagamento">
                        <VueMultiselect
                            v-model="terminiDiPagamentoAutocomplete.selection"
                            :options="terminiDiPagamentoAutocomplete.options"
                            @search-change="terminiDiPagamentoAutocomplete.search"
                            :loading="terminiDiPagamentoAutocomplete.isLoading"
                            placeholder="Scegli termine di pagamento"
                            class="next-vue-multiselect-single"
                            track-by="id"
                            label="descrizione"
                            selectLabel=""
                            deselectLabel=""
                            selectedLabel=""
                            :internal-search="true"
                        >
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="col-span-2 flex flex-col mb-3">

                    <Field field_name="Business unit">
                        <VueMultiselect :searchable="true"
                                        :loading="buAutocomplete.isLoading"
                                        :internal-search="false"
                                        trackBy="id"
                                        label="nome"
                                        @search-change="buAutocomplete.search"
                                        v-model="buAutocomplete.selection"
                                        :options="buAutocomplete.options"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        class="next-vue-multiselect-single"
                                        placeholder="Business Unit"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                        >
                            <template v-slot:option="{option, props}">
                                <span
                                    class="relative inline-block p-2 group">
                                    <span class="mr-2 border border-next p-1">{{ option.label }}</span><span
                                    class="mr-1">{{ option.nome }}</span>
                                </span>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="col-span-2 flex flex-col mb-3">
                    <Field field_name="Cliente" placeholder="Cliente">
                        <VueMultiselect @search-change="clienteAutocomplete.search"
                                        :loading="clienteAutocomplete.isLoading"
                                        :options="clienteAutocomplete.options"
                                        v-model="clienteAutocomplete.selection"
                                        track-by="id" label="denominazione"
                                        class="next-vue-multiselect-single"
                                        placeholder="Cliente"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                            <template v-slot:singleLabel="{option}">
                                {{ `${option.denominazione} - ${option.ragione_sociale}` }}
                            </template>
                            <template v-slot:option="{option}">{{
                                    `${option.denominazione} - ${option.ragione_sociale}`
                                }}
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Scadenza dal"
                           type="date"
                           v-model="filtri.scadenza_dal">
                    </Field>
                </div>
                <div class="flex flex-col">
                    <Field field_name="Scadenza al"
                           type="date"
                           v-model="filtri.scadenza_al">
                    </Field>
                </div>
                <div class="col-span-3 flex flex-col">
                    <Field v-model="listaPianoFatturazione.search"
                           field_name="Cerca"
                           placeholder="Cerca"></Field>
                </div>
            </div>


            <div class="flex justify-end">
                <Paginator :pagination="listaPianoFatturazione.paginate"></Paginator>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 pl-5 py-4 table-fixed"
                           v-model:cols="pianoDiFatturazioneCols"
                           :pagination="listaPianoFatturazione.paginate"
                           :rows="listaPianoFatturazione.rows" @order-update="listaPianoFatturazione.updateCols">
                    <template v-for="(c, j) in listaPianoFatturazione.rows" :key="j" v-slot:[`td_${j}_0`]="context">
                        <div v-if="context.context.row.righe.length != 0"
                             class="table-curtain-icon absolute top-0 bottom-0 flex items-center px-3 group"
                             :class="{open: c.expanded}" @click="c.expanded=!c.expanded">
                            <i class="fas fa-caret-right text-xl group-hover:text-next-orange duration-300 ease-in-out"></i>
                        </div>
                        {{ context.context.row.cod_nodo }}
                    </template>
                    <template v-for="(c, j) in listaPianoFatturazione.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                        {{ $filters.toCurrency(TotaleRighePianoDiFatturazione(c.righe)) }}
                    </template>
                    <template v-for="(c, j) in listaPianoFatturazione.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                        {{ $filters.toDate(c.data_emissione_fattura) }}
                    </template>
                    <template v-for="(c, j) in listaPianoFatturazione.rows" :key="j" v-slot:[`td_${j}_6`]="{context}">
                        {{ context.row[context?.cell?.prop] }}
                        <a v-if="context.row?.allegato_file_id" @click.stop=""
                           class="block underline text-sm text-next-atp whitespace-nowrap  cursor-pointer"
                           @click="downloadFile(context.row?.allegato_file_id)">
                            Scarica allegato
                        </a>
                    </template>
                    <template v-for="(c, j) in listaPianoFatturazione.rows" :key="j" v-slot:[`td_${j}_7`]="context">
                        <router-link
                            :to="{name:'SottoProgettoPianoFatturazione', params:{id:context.context.row.sottoprogetto_id}}"
                            class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>

                    <template v-for="(c, j) in listaPianoFatturazione.rows" :key="j"
                              v-slot:[`td_child_${j}`]="{context}">
                        <template v-if="c.expanded">
                            <tr v-for="(cc, i) in context.row.righe" :key="i" class="h-5 text-sm">
                                <td colspan="2" class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark"></td>
                                <td class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                    {{ cc.iva.descrizione }}
                                </td>
                                <td class="px-2 bg-transparent text-right border-b-2 border-b-next-gray-md-dark">
                                    {{ $filters.toEuroCurrency(Number(cc.valore)) }}
                                </td>
                                <td colspan="4" class="px-2 bg-transparent border-b-2 border-b-next-gray-md-dark">
                                    {{ cc.note }}
                                </td>
                            </tr>
                        </template>
                    </template>
                </NextTable>

            </div>
            <InfiniteLoading @infinite="listaPianoFatturazione.fetchNextPage"
                             :identifier="listaPianoFatturazione.infiniteIdentifier"
                             style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altri piani di fatturazione.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import InfiniteLoading from "v3-infinite-loading";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import Lista from "@/setup/ListaCerca";
import pianoDiFatturazioneManager from "../api/PianoDiFatturazione";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import Field from "@/components/Field.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Autocomplete from "@/setup/Autocomplete";
import terminiPagamentoManager from "../api/TerminiPagamento";
import businessUnitsManager from "../api/BusinessUnits";
import clientiManager from "../api/Clienti";
import statoPianificazioneManager from "../api/StatoPianificazioneManager";

@Options({
    name: 'ListaPianoDiFatturazione',
    methods: {
        statoPianificazioneManager() {
            return statoPianificazioneManager
        }
    },
    inject: ['downloadFile'],
    components: {
        MultiselectOption, Field,
        NextTable,
        Paginator,
        InfiniteLoading,
        ContextMenu,
        Loading
    }
})
export default class ListaPianoDiFatturazione extends Vue {

    loading = false
    visible = false
    cm_visible = -1

    statoPianificazioneManager = statoPianificazioneManager
    listaPianoFatturazione: any = setup(() => Lista(pianoDiFatturazioneManager, this.pianoDiFatturazioneCols))
    terminiDiPagamentoAutocomplete: any = setup(() => Autocomplete(terminiPagamentoManager))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, false))
    clienteAutocomplete: any = setup(() => Autocomplete(clientiManager))

    stato_options = [{id: 0, text: 'Pianificato'}, {id: 1, text: 'Da fatturare'}, {id: 2, text: 'Fatturato'}]
    stato_filter: any = this.stato_options[1]


    filtri = {
        scadenza_dal: '',
        scadenza_al: '',
    }

    @Watch('listaPianoFatturazione.search')
    listaPianoFatturazioneChange(new_value: any) {
        this.resetView()
    }

    @Watch('filtri', {deep: true})
    @Watch('terminiDiPagamentoAutocomplete.selection')
    @Watch('buAutocomplete.selection')
    @Watch('clienteAutocomplete.selection')
    @Watch('stato_filter',)
    filtriChange() {
        this.listaPianoFatturazione.apiParams = {
            stato: '' || this.stato_filter?.id,
            data_al: '' || this.filtri.scadenza_al,
            data_dal: '' || this.filtri.scadenza_dal,
            termini: '' || this.terminiDiPagamentoAutocomplete.selection?.id,
            bu: '' || this.buAutocomplete.selection?.id,
            cliente: '' || this.clienteAutocomplete.selection?.id
        }
        this.resetView()
    }

    mounted() {
        this.listaPianoFatturazione.sort = 'data_emissione_fattura'
        this.filtriChange()
        this.terminiDiPagamentoAutocomplete.search('', 0)
        this.buAutocomplete.search('', 0)
        this.clienteAutocomplete.search('', 0)
    }

    resetView() {
        this.listaPianoFatturazione.debounceSearch()
    }

    TotaleRighePianoDiFatturazione(righe: any[]) {
        return righe.reduce((val, row: any) => {
            return val + Number(row.valore)
        }, 0)
    }

    pianoDiFatturazioneCols = [
        {
            name: 'Cod. nodo',
            prop: 'cod_nodo',
            orderable: true,
            class: 'text-left min-w-200 w-36 whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Cod. odv',
            prop: 'cod_odv',
            orderable: true,
            class: 'text-left min-w-200 w-36 whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Descrizione',
            prop: 'descrizione',
            orderable: true,
            class: 'text-left min-w-285 w-36 whitespace-nowrap',
            td_class: 'h-11.5 px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Valore',
            prop: 'valore',
            orderable: true,
            class: 'text-left min-w-285 whitespace-nowrap',
            td_class: 'h-11.5 px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Termine pagamento',
            prop: 'termine_pagamento_descrizione',
            orderable: true,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data fattura',
            prop: 'data_emissione_fattura',
            orderable: true,
            class: 'text-left min-w-36 w-36 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'stato_descrizione',
            ordProp: 'conferma',
            orderable: true,
            class: 'text-left whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },

    ]
}

</script>


<style lang="scss">
.home {
    background-color: green;
}
</style>

<script setup lang="ts">
</script>
